import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "review-table" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", null, "First Name:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", null, "Last Name:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, "Middle Initial:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", null, "Email address:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, "Phone number:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Date of birth (mm/dd/yyyy):", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "City:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "State:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Zip code:", -1)

import { computed } from "vue";
import FsaVariables from "@/types/FsaVariables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewPatientInfo',
  props: {
    variables: {}
  },
  emits: ["update:variables"],
  setup(__props: any, { emit }) {

const props = __props;




const variables = computed({
  get() {
    return props.variables;
  },
  set(value) {
    emit("update:variables", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createElementVNode("td", null, _toDisplayString(variables.value.firstName), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_3,
      _createElementVNode("td", null, _toDisplayString(variables.value.lastName), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_4,
      _createElementVNode("td", null, _toDisplayString(variables.value.middleInitial), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_5,
      _createElementVNode("td", null, _toDisplayString(variables.value.email), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_6,
      _createElementVNode("td", null, _toDisplayString(variables.value.phoneNumber?.replace(
            /^(\d{3})(\d{3})(\d{4})$/,
            "($1) $2-$3"
          )), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_7,
      _createElementVNode("td", null, _toDisplayString(variables.value.dateOfBirth), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_8,
      _createElementVNode("td", null, _toDisplayString(variables.value.addressCity), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_9,
      _createElementVNode("td", null, _toDisplayString(variables.value.addressState), 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_10,
      _createElementVNode("td", null, _toDisplayString(variables.value.addressZip), 1)
    ])
  ]))
}
}

})